// extracted by mini-css-extract-plugin
export default {"logo_title":"headerLogo_logo_title__DfjBr"};